<div class="page status-page">
  <div class="status-card" *ngIf="loading">
    <h1>正在驗證電郵地址...</h1>
    <p>請稍候，系統正在聯絡伺服器。</p>
  </div>

  <div class="status-card success" *ngIf="!loading && success">
    <h1>恭喜您，已通過電郵地址驗證！</h1>
    <p *ngIf="project != 'hklsc_ccec'">你稍後會收到一封通知郵件，賬戶將由管理員進一步審核。</p>
    <a routerLink="/">返回註冊頁面</a>
  </div>

  <div class="status-card error" *ngIf="!loading && error">
    <h1>對不起！發生一些錯誤。</h1>
    <p>{{ error }}</p>
    <a routerLink="/">回到註冊頁面</a>
  </div>
</div>
